import {
  IProjectGroupProject,
  IProjectGroupProjectLight,
} from '@/redux/projectGroup/projectGroup.d';
import DownloadProjectGroupModal from './DownloadProjectGroupModal';

interface DownloadProjectGroupButtonProps {
  projectGroupId: string;
  projectGroupName: string;
  totalPartsCount?: number;
  projects: (IProjectGroupProject | IProjectGroupProjectLight)[];
}

export default function DownloadProjectGroupButton({
  projectGroupId,
  projectGroupName,
  totalPartsCount,
  projects,
}: DownloadProjectGroupButtonProps) {
  return (
    <DownloadProjectGroupModal
      projectGroupId={projectGroupId}
      projectGroupName={projectGroupName}
      totalPartsCount={totalPartsCount}
      projects={projects}
    />
  );
}
